/* VCTparts: "Past in jouw auto", built on the car a customer chose in the
   fitting finder (snippets/fitting-zoeker.liquid). The finder stores the car
   (localStorage "gfzVehicle3") and the bulb codes per position for that car
   ("gfzFit1"). This script only does something once a car is known:
   - header, mobile menu and homepage block show the car instead of the
     question (snippets/vct-fz-entry.liquid, sections/vct-lampzoeker.liquid);
   - the fit card on lamp product pages (snippets/vct-fz-fitline.liquid)
     says whether this lamp fits that car, with the brand logo and a small
     disclaimer;
   - product cards get a "Past in jouw Golf" label when the lamp's code is
     the only version for a position of that car.
   A lamp matches when its title (and on the product page its tags) contains
   the code, exactly like the finder's own recommendations. Codes that the
   car does not use are only flagged for headlight bulbs (H1-H19, HB3/HB4,
   HIR, xenon D-codes), where the code on the product is unambiguous.
   The homepage plate form hands the plate over in sessionStorage, so the
   plate never ends up in a URL. */
(function () {
  'use strict';

  var CAR_KEY = 'gfzVehicle3';
  var FIT_KEY = 'gfzFit1';
  var PLATE_KEY = 'vct-fz-plate';
  var VW_H7_HANDLE = 'halovision-volkswagen-specifieke-h7-led-40w-8000lm-6000k-direct-fit-zonder-adapters-golf-6-7-passat-touran-tiguan-scirocco';
  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();

  var T = {
    nl: {
      yourCar: 'Jouw auto',
      navCar: 'Lampen voor jouw {car}',
      homeTitle: 'Lampen voor jouw {car}',
      homeSub: 'Bekijk direct alle lampen en fittingen van jouw auto.',
      lead: {
        fit: 'Deze lamp past in de',
        maybe: 'Deze lamp kan passen in de',
        vw: 'Voor de',
        nofit: 'Deze lamp past niet in de',
        car: 'Jouw auto'
      },
      detail: {
        maybe: 'Er bestaan meerdere uitvoeringen: check de code op je huidige lamp.',
        vw: 'adviseren we de VW-specifieke H7, die past zonder adapter.',
        nofit: 'Volgens onze gegevens zit er geen {code} in deze auto.',
        car: 'Bekijk welke lampen erin passen.'
      },
      edit: 'Andere auto kiezen',
      view: 'Bekijk',
      card: 'Past in jouw {model}',
      and: 'en',
      disclaimer: 'Dit is enkel een advies; we zijn niet verantwoordelijk voor fouten. Zeker weten? Haal de originele lamp eruit en bekijk de fitting die erop staat.'
    },
    de: {
      yourCar: 'Dein Auto',
      navCar: 'Passende Lampen: {car}',
      homeTitle: 'Passende Lampen für dein Auto: {car}',
      homeSub: 'Sieh dir sofort alle Lampen und Fassungen deines Autos an.',
      lead: {
        fit: 'Diese Lampe passt in dein Auto:',
        maybe: 'Diese Lampe kann in dein Auto passen:',
        vw: 'Für dein Auto:',
        nofit: 'Diese Lampe passt nicht in dein Auto:',
        car: 'Dein Auto'
      },
      detail: {
        maybe: 'Es gibt mehrere Ausführungen: prüfe den Code auf deiner aktuellen Lampe.',
        vw: 'empfehlen wir die VW-spezifische H7, sie passt ohne Adapter.',
        nofit: 'Laut unseren Daten hat dieses Auto keine {code}.',
        car: 'Sieh dir an, welche Lampen passen.'
      },
      edit: 'Anderes Auto wählen',
      view: 'Ansehen',
      card: 'Passt zu deinem {model}',
      and: 'und',
      disclaimer: 'Dies ist nur eine Empfehlung; für Fehler übernehmen wir keine Haftung. Ganz sicher sein? Nimm die originale Lampe heraus und sieh dir die Fassung darauf an.'
    },
    fr: {
      yourCar: 'Votre voiture',
      navCar: 'Ampoules pour votre {car}',
      homeTitle: 'Ampoules pour votre {car}',
      homeSub: 'Voyez immédiatement toutes les ampoules et culots de votre voiture.',
      lead: {
        fit: 'Cette ampoule est compatible avec votre',
        maybe: 'Cette ampoule peut convenir à votre',
        vw: 'Pour votre',
        nofit: 'Cette ampoule n’est pas compatible avec votre',
        car: 'Votre voiture'
      },
      detail: {
        maybe: 'Il existe plusieurs versions : vérifiez le code sur votre ampoule actuelle.',
        vw: 'nous conseillons la H7 spécifique VW, qui se monte sans adaptateur.',
        nofit: 'Selon nos données, cette voiture n’utilise pas de {code}.',
        car: 'Voir les ampoules compatibles.'
      },
      edit: 'Choisir une autre voiture',
      view: 'Voir',
      card: 'Compatible {model}',
      and: 'et',
      disclaimer: 'Ceci n’est qu’un conseil ; nous déclinons toute responsabilité en cas d’erreur. Pour en être certain, retirez l’ampoule d’origine et vérifiez le culot indiqué dessus.'
    },
    en: {
      yourCar: 'Your car',
      navCar: 'Bulbs for your {car}',
      homeTitle: 'Bulbs for your {car}',
      homeSub: 'See all the bulbs and fittings of your car right away.',
      lead: {
        fit: 'This bulb fits the',
        maybe: 'This bulb may fit the',
        vw: 'For the',
        nofit: 'This bulb does not fit the',
        car: 'Your car'
      },
      detail: {
        maybe: 'There are several versions: check the code on your current bulb.',
        vw: 'we recommend the VW-specific H7, which fits without an adapter.',
        nofit: 'According to our data this car does not use {code}.',
        car: 'See which bulbs fit.'
      },
      edit: 'Choose another car',
      view: 'View',
      card: 'Fits your {model}',
      and: 'and',
      disclaimer: 'This is only advice; we are not responsible for errors. Want to be sure? Take out the original bulb and check the fitting printed on it.'
    }
  };
  var t = T[LANG] || T.nl;

  /* Same line icons as snippets/vct-icon.liquid */
  var ICONS = {
    'check-circle': '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    alert: '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    car: '<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    question: '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
    pencil: '<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/>'
  };
  function icon(name, size) {
    return '<svg class="vct-icon" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICONS[name] + '</svg>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fill(str, vars) {
    return str.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] == null ? '' : vars[k]; });
  }
  /* Only touch the DOM when something changed (keeps focus and avoids
     waking the observer for nothing) */
  function setText(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }
  function setHtml(node, value) {
    if (node.getAttribute('data-vct-html') !== value) {
      node.innerHTML = value;
      node.setAttribute('data-vct-html', value);
    }
  }
  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  /* ---- The chosen car and its codes ------------------------------------ */

  function getCar() {
    var v = read(CAR_KEY);
    return v && v.make && v.model && v.year ? v : null;
  }
  function getProfile(v) {
    var p = read(FIT_KEY);
    if (!v || !p || p.v !== 1) return null;
    return p.key === [v.make, v.model, v.year, v.tech || ''].join('|') ? p : null;
  }
  function modelName(v) { return v.modelLabel || v.model; }
  function carName(v) { return v.make + ' ' + modelName(v); }
  function carNameYear(v) { return carName(v) + ' (' + v.year + ')'; }

  /* ---- Matching (same rules as the finder's recommendations) ----------- */

  /* Other names for the same bulb on product titles */
  var ALIASES = {
    W5W: ['T10'], W21W: ['T20', '7440'], 'W21/5W': ['7443'],
    P21W: ['BA15S', '1156'], PY21W: ['BAU15S'], 'P21/5W': ['BAY15D', '1157'],
    HB3: ['9005'], HB4: ['9006'], HIR2: ['9012']
  };
  var EXCLUDE_RE = /decoder|weerstand|belasting|adapter|verloop|houder|socket|ombouw|kabel|tester/i;
  var HEADLIGHT_RE = /(^|[^A-Za-z0-9])(H(?:1|3|4|7|8|9|11|13|15|16|18|19)|HB[34]|HIR[12]|D[1-58][SR]|9005|9006|9012)(?=[^A-Za-z0-9]|$)/gi;

  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hasCode(code, text) {
    return new RegExp('(^|[^A-Za-z0-9])' + escRe(code) + '([^A-Za-z0-9]|$)', 'i').test(text);
  }
  function findCode(map, text) {
    var codes = Object.keys(map || {});
    for (var i = 0; i < codes.length; i++) {
      var names = [codes[i]].concat(ALIASES[codes[i].toUpperCase()] || []);
      for (var n = 0; n < names.length; n++) {
        if (hasCode(names[n], text)) return { code: codes[i], pos: map[codes[i]] };
      }
    }
    return null;
  }
  function isVwH7(title, handle) {
    return handle === VW_H7_HANDLE || /volkswagen[\s-]+specifieke/i.test(title);
  }

  /* fit | maybe | vw | nofit | car */
  function verdict(p, title, tags, handle) {
    if (!p || EXCLUDE_RE.test(title)) return { type: 'car' };
    var text = title + ' ' + (tags || '');
    var sure = findCode(p.sure, text);
    if (sure) {
      /* VW plastic H7 holder: a regular H7 LED does not fit directly */
      if (p.vwH7 && sure.code.toUpperCase() === 'H7' && /\bled\b/i.test(title) && !isVwH7(title, handle)) {
        return { type: 'vw', code: 'H7', pos: sure.pos };
      }
      return { type: 'fit', code: sure.code, pos: sure.pos };
    }
    var maybe = findCode(p.maybe, text);
    if (maybe) return { type: 'maybe', code: maybe.code, pos: maybe.pos };
    HEADLIGHT_RE.lastIndex = 0;
    var m = HEADLIGHT_RE.exec(title);
    if (m) return { type: 'nofit', code: m[2].toUpperCase() };
    return { type: 'car' };
  }

  function positions(list) {
    /* Positions come from the Dutch data, so they are only shown in Dutch */
    if (LANG !== 'nl' || !list || !list.length) return '';
    var names = list.map(function (p) { return String(p).toLowerCase(); });
    var last = names.pop();
    var out = (names.length ? names.join(', ') + ' ' + t.and + ' ' : '') + last;
    return out.charAt(0).toUpperCase() + out.slice(1);
  }

  /* ---- Product page card ---------------------------------------------- */

  var LOGO_BASE = 'https://cdn.shopify.com/s/files/1/0871/5904/6480/files/carlogo-';
  var BADGE = { fit: 'check', maybe: 'question', vw: 'question', nofit: 'x' };

  function renderLines(v, p) {
    var cards = document.querySelectorAll('[data-vct-fitline]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var tile = card.querySelector('[data-vct-fitline-tile]');
      var text = card.querySelector('[data-vct-fitline-text]');
      var btn = card.querySelector('[data-vct-fitline-btn]');
      if (!tile || !text || !btn) continue;
      if (!card.hasAttribute('data-vct-default')) {
        card.setAttribute('data-vct-default', '1');
        tile.setAttribute('data-vct-default', tile.innerHTML);
        text.setAttribute('data-vct-default', text.innerHTML);
        btn.setAttribute('data-vct-default', btn.innerHTML);
        btn.setAttribute('data-vct-label', btn.getAttribute('aria-label') || '');
      }
      if (!v) {
        setHtml(tile, tile.getAttribute('data-vct-default'));
        setHtml(text, text.getAttribute('data-vct-default'));
        setHtml(btn, btn.getAttribute('data-vct-default'));
        btn.setAttribute('aria-label', btn.getAttribute('data-vct-label'));
        card.removeAttribute('data-state');
        removeNote(card);
        continue;
      }
      var r = verdict(p, card.getAttribute('data-title') || '', card.getAttribute('data-tags') || '', card.getAttribute('data-handle') || '');
      var detail = '';
      if (r.type === 'fit') {
        detail = esc(positions(r.pos));
      } else if (r.type === 'vw') {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        detail = esc(t.detail.vw) + ' <a class="vct-fitcard__link" href="' + root.replace(/\/?$/, '/') + 'products/' + VW_H7_HANDLE + '">' + esc(t.view) + '</a>';
      } else {
        detail = esc(fill(t.detail[r.type], { code: r.code || '' }));
      }
      var logo = '<img src="' + LOGO_BASE + esc(String(v.make).toLowerCase().replace(/\s+/g, '-')) + '.png" alt="" width="40" height="40" loading="lazy">';
      var badge = BADGE[r.type] ? '<span class="vct-fitcard__badge">' + icon(BADGE[r.type], 12) + '</span>' : '';
      setHtml(tile, logo + badge);
      setHtml(text,
        '<span class="vct-fitcard__lead">' + esc(t.lead[r.type]) + '</span>' +
        '<strong class="vct-fitcard__car">' + esc(carNameYear(v)) + '</strong>' +
        (detail ? '<span class="vct-fitcard__detail">' + detail + '</span>' : ''));
      setHtml(btn, icon('pencil', 18));
      btn.setAttribute('aria-label', t.edit);
      card.setAttribute('data-state', r.type);
      var img = tile.querySelector('img');
      if (img && !img.hasAttribute('data-vct-watch')) {
        img.setAttribute('data-vct-watch', '');
        img.addEventListener('error', function () {
          /* No logo for this make: the car icon instead */
          this.parentNode.insertAdjacentHTML('afterbegin', icon('car', 28));
          this.parentNode.removeChild(this);
        });
      }
      if (r.type === 'car') removeNote(card);
      else addNote(card);
    }
  }
  function addNote(card) {
    var note = card.nextElementSibling;
    if (note && note.classList.contains('vct-fitcard-note')) return;
    note = document.createElement('p');
    note.className = 'vct-fitcard-note';
    note.textContent = t.disclaimer;
    card.parentNode.insertBefore(note, card.nextSibling);
  }
  function removeNote(card) {
    var note = card.nextElementSibling;
    if (note && note.classList.contains('vct-fitcard-note')) note.parentNode.removeChild(note);
  }

  /* ---- Header, mobile menu, homepage ----------------------------------- */

  function renderEntries(v) {
    var i;
    var kickers = document.querySelectorAll('[data-vct-fz-kicker]');
    var labels = document.querySelectorAll('[data-vct-fz-label]');
    var longs = document.querySelectorAll('[data-vct-fz-label-long]');
    var nodes = [].slice.call(kickers).concat([].slice.call(labels), [].slice.call(longs));
    for (i = 0; i < nodes.length; i++) {
      if (!nodes[i].hasAttribute('data-vct-default')) nodes[i].setAttribute('data-vct-default', nodes[i].textContent);
    }
    for (i = 0; i < kickers.length; i++) setText(kickers[i], v ? t.yourCar : kickers[i].getAttribute('data-vct-default'));
    for (i = 0; i < labels.length; i++) setText(labels[i], v ? carName(v) : labels[i].getAttribute('data-vct-default'));
    for (i = 0; i < longs.length; i++) setText(longs[i], v ? fill(t.navCar, { car: carName(v) }) : longs[i].getAttribute('data-vct-default'));

    var homes = document.querySelectorAll('[data-vct-fz-home]');
    for (i = 0; i < homes.length; i++) {
      var home = homes[i];
      var title = home.querySelector('[data-vct-fz-home-title]');
      var sub = home.querySelector('[data-vct-fz-home-sub]');
      var fresh = home.querySelector('[data-vct-fz-home-new]');
      var saved = home.querySelector('[data-vct-fz-home-saved]');
      if (title && !title.hasAttribute('data-vct-default')) title.setAttribute('data-vct-default', title.textContent);
      if (sub && !sub.hasAttribute('data-vct-default')) sub.setAttribute('data-vct-default', sub.textContent);
      if (title) setText(title, v ? fill(t.homeTitle, { car: carNameYear(v) }) : title.getAttribute('data-vct-default'));
      if (sub) setText(sub, v ? t.homeSub : sub.getAttribute('data-vct-default'));
      if (fresh && fresh.hidden !== !!v) fresh.hidden = !!v;
      if (saved && saved.hidden !== !v) saved.hidden = !v;
    }
  }

  /* ---- Product cards --------------------------------------------------- */

  function renderCards(v, p) {
    var cards = document.querySelectorAll('.l4cl .product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var badge = card.querySelector('.vct-fit-badge');
      var link = card.querySelector('h3 a');
      var figure = card.querySelector('figure');
      var show = false;
      if (v && p && link && figure) {
        var r = verdict(p, link.textContent || '', '', (link.getAttribute('href') || '').split('/products/')[1] || '');
        show = r.type === 'fit';
      }
      if (show && !badge) {
        badge = document.createElement('span');
        badge.className = 'vct-fit-badge';
        badge.innerHTML = icon('check', 14) + '<span>' + esc(fill(t.card, { model: modelName(v) })) + '</span>';
        figure.appendChild(badge);
      } else if (!show && badge) {
        badge.parentNode.removeChild(badge);
      }
    }
  }

  /* ---- Homepage plate form and "other car" ----------------------------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-vct-fz-plateform')) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var plate = String(input && input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (plate.length >= 4) {
      try { sessionStorage.setItem(PLATE_KEY, plate); } catch (err) {}
    }
    window.location.href = form.getAttribute('action');
  });
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-vct-fz-new]') : null;
    if (!link) return;
    try { localStorage.removeItem(CAR_KEY); localStorage.removeItem(FIT_KEY); } catch (err) {}
  });

  /* ---- Wiring ---------------------------------------------------------- */

  var observer = null;
  var timer = null;

  function run() {
    timer = null;
    var v = getCar();
    var p = getProfile(v);
    renderEntries(v);
    renderLines(v, p);
    renderCards(v, p);
    if (observer) observer.takeRecords();
    /* Cards come and go (filters, sliders, recommendations): only watch
       the page when there is a car to show */
    if (v && p && !observer && 'MutationObserver' in window) {
      observer = new MutationObserver(function () { if (!timer) timer = setTimeout(run, 150); });
      observer.observe(document.body, { childList: true, subtree: true });
    } else if (!(v && p) && observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function init() {
    run();
    document.addEventListener('vct:fit', run);
    window.addEventListener('storage', function (e) {
      if (e.key === CAR_KEY || e.key === FIT_KEY) run();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
